import { render, staticRenderFns } from "./tutor_unit_activity_view.vue?vue&type=template&id=eb2bf886&"
import script from "./tutor_unit_activity_view.vue?vue&type=script&lang=js&"
export * from "./tutor_unit_activity_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports